import type { ImageUploadAdapter } from '@pbk-web/lexical';

const MOCK_LATENCY_MS = 400;

// Mock ids only live for this tab, standing in for the API's file store
const mockFiles = new Map<string, string>();

/**
 * MOCK: keeps images in memory as object URLs instead of uploading them.
 * - Swap for an API-backed adapter (e.g. `FileService`) without touching any editor.
 */
const mockImageUploadAdapter: ImageUploadAdapter = {
  upload: (blob) =>
    new Promise((resolve) => {
      setTimeout(() => {
        const fileId = `mock-${crypto.randomUUID()}`;
        const url = URL.createObjectURL(blob);
        mockFiles.set(fileId, url);
        resolve({ url, fileId });
      }, MOCK_LATENCY_MS);
    }),
  resolve: (fileId) => {
    const url = mockFiles.get(fileId);
    return url ? Promise.resolve(url) : Promise.reject(new Error(`Unknown mock file ${fileId}`));
  },
};

/** The adapter every rich-text editor uploads images through. */
export const imageUploadAdapter: ImageUploadAdapter = mockImageUploadAdapter;
